import React from 'react'
import MathiasVerraesImg from '../../images/speakers/Mathias-Verraes.jpg'


const MathiasVerraes = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
        <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
				<div className="team-wrapper">
					<h2>Mathias Verraes</h2>
						<div className="row">
                            <div className="col-md-6">
                                <img src={MathiasVerraesImg} className="img-responsive" alt="Mathias Verraes" />
                                <ul className="social-icon">
									<li><a href="https://www.linkedin.com/in/mathiasverraes/" target="_blank" className="fa fa-linkedin wow fadeIn"></a></li>
									<li><a href="https://twitter.com/mathiasverraes" target="_blank" className="fa fa-twitter wow fadeIn"></a></li>
							        <li><a href="http://verraes.net" target="_blank" className="fa fa-bookmark wow fadeIn"></a></li>
								</ul>
                            </div>
                         <div className="col-md-5">
							<p>
                            Mathias Verraes advises companies on building software for complex environments. 
                            This involves primarily analysis and modelling, but also code, architecture, testing, and refactoring “unmaintainable” systems. 
                            He has worked with clients in Finance, Automotive, Government, Logistics, E-Commerce, and more. 
                            <br />
                            He teaches Domain-Driven Design courses and co-organises and curates the DDD Europe conference. When he’s not working, he’s at home in Kortrijk, Belgium, helping his two sons build crazy Lego train tracks.
							</p>
                           </div>
                        </div>
                        <div className="row">
							<h4>Keynote: Temporal Coupling</h4>
							<p>
							Event Storming, Event Sourcing, CQRS, messaging, distributed systems … In one way or another, they’re all about time. Traditional modelling styles, focused on things and structures, are not the primary way anymore to build modern systems that handle complexity well. Object-oriented models tend to have an uneasy relation with events happening over time. The actual business processes, the heart of how organisations operate, end up hidden in the many calls between objects.
                            <br /><br />
                            Temporal Modelling is the cure: build models and systems that make events and processes the first class building blocks of a domain model. In this talk, we’re going to look at how reasoning with time helps us better understand how to build our software.
							</p>
						</div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default MathiasVerraes


// WEBPACK FOOTER //
// ./src/pages/speakers/mathias-verraes.js